type StorageName = 'localStorage' | 'sessionStorage';

const fallbacks: Record<StorageName, Map<string, string>> = {
  localStorage: new Map(),
  sessionStorage: new Map()
};

// Accessing web storage throws SecurityError when the browser blocks site data.
export class SafeStorage {
  constructor(private readonly storageName: StorageName) {}

  getItem(key: string): string | null {
    try {
      return window[this.storageName].getItem(key);
    } catch {
      return fallbacks[this.storageName].get(key) ?? null;
    }
  }

  setItem(key: string, value: string): void {
    try {
      window[this.storageName].setItem(key, value);
    } catch {
      fallbacks[this.storageName].set(key, value);
    }
  }
}

export const safeLocalStorage = new SafeStorage('localStorage');
export const safeSessionStorage = new SafeStorage('sessionStorage');
